// @flow
export const getReviewAddText = (arr: Array<any>, type: string): string =>
  arr.length ? `Add another ${type}` : `Add ${type} to continue`;
export const getReviewAddTextSegment = (
  segmentsAvailable: number,
  type: string,
): string =>
  segmentsAvailable >= 1 ? `Add another ${type}` : `Add ${type} to continue`;
